module.exports = __webpack_public_path__ + "img/OverseaMember68.f397e729.png";